/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CannotProcessPermit.module.scss'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'

const CannotProcessPermitView = ({ t, i18n }) => {
  const history = useHistory()

  const nsLocationsURL = i18n.language === 'en' ? 'https://novascotia.ca/access-locations/' : 'https://novascotia.ca/access-locations/fr/'

  const getPhoneNumber = () => {
    return `tel:${t('cannot_process_permit.number')}`
  }

  const getPayAFineUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://dev-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://test-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-finepayments.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://uat-finepayments.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else {
      return i18n.language === 'en'
        ? 'https://finepayment.novascotia.ca/en/privacy-notice'
        : 'https://finepayment.novascotia.ca/fr/avis-de-confidentialite'
    }
  }

  const getPayFeesUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://dev-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://test-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://uat-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else {
      return i18n.language === 'en'
        ? 'https://rmvadminfeepayment.novascotia.ca/en/privacy-notice'
        : 'https://rmvadminfeepayment.novascotia.ca/fr/avis-de-confidentialite'
    }
  }

  const cancelURL = useMemo(() => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-renewvehiclepermit.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://dev-renewvehiclepermit.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-renewvehiclepermit.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://test-renewvehiclepermit.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-renewvehiclepermit.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://uat-renewvehiclepermit.ds4u.novascotia.dev/fr/avis-de-confidentialite'
    } else {
      return i18n.language === 'en'
        ? 'https://renewvehiclepermit.novascotia.ca/en/privacy-notice'
        : 'https://renewvehiclepermit.novascotia.ca/fr/avis-de-confidentialite'
    }
  }, [i18n.language])

  const payAFineUrl = getPayAFineUrl()
  const payFeesUrl = getPayFeesUrl()

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <BackAnchor backPath="routes.your_info" />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h2>{t('cannot_process_permit.we_cannot_process')}</h2>
          <h3>{t('cannot_process_permit.your_information_either')}</h3>
          <ul>
            <li>
              <a
                onClick={() => history.push(`/${i18n.language}${t('routes.your_info')}`)}
                href={`/${i18n.language}${t('routes.your_info')}`}
              >
                {t('cannot_process_permit.go_back_and')}
              </a>
              .
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href={payAFineUrl}>
                {t('cannot_process_permit.pay_any_outstanding_fines')}
              </a>
              .
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href={payFeesUrl}>
                {t('cannot_process_permit.pay_any_outstanding_fees')}
              </a>
              .
            </li>
          </ul>
          <h3>{t('cannot_process_permit.if_you_are')}</h3>
          <ul>
            <li>
              {t('cannot_process_permit.for_more_info')}
              <a href={getPhoneNumber()}>{t('cannot_process_permit.number')}</a>
              {t('cannot_process_permit.or_visit_an')}
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={i18n.language === 'en' ? 'https://novascotia.ca/access-locations/' : 'https://novascotia.ca/access-locations/fr/'}
              >
                {t('cannot_process_permit.find_out')}
              </a>
              .
            </li>
          </ul>
        </div>
      </div>
      <div className={styles['back_next_margin']}>
        <div style={{ display: 'flex', marginTop: '30px' }}>
          <button
            className={['btn-lg btn-default', styles['margin_zero']].join(' ')}
            onClick={() => window.location.assign(nsLocationsURL)}
            name={t('cannot_process_permit.find_location')}
            value={t('cannot_process_permit.find_location')}
          >
            {t('cannot_process_permit.find_location')}
          </button>
          {/* <div className={styles['cancel_center_margin']}>
            <a href={cancelURL}>{t('cannot_process_permit.cancel')}</a>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(CannotProcessPermitView)
